/* eslint-disable import/first */
import React, { useState } from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useIntl } from 'react-intl';
import { useNavigate, useLocation } from '@reach/router';
const { selectOrderModesByCountry } = Slices.configSlice;
/* eslint-disable import/first */
import compact from 'lodash/compact';
import { Redux, Slices } from 'spwa-ui-library';
import css from './index.module.scss';
import { addDesktopRepository } from 'spwa-ui-library/esm/utils/helper';
import noImg from '../../assets/no-itm.png';
import BundleGroupDialog from '../ProductTileList/BundleGroupDialog';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import SwipeableViews from 'react-swipeable-views';
const { useSelector, useDispatch } = Redux;

const { getClusterId, selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDesktop } = Slices.appSlice;
const { addProductToCustomize } = Slices.tempCartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectProductEntities, getProductInfo, addNewProduct } = Slices.productSlice;
let scrollTimerInstance = null;
export default function BannerMedium({ widgetData }) {
  const { media, content } = widgetData;
  const dispatch = useDispatch();
  const [showBundleGroupDialog, setShowBundleGroupDialog] = useState(0);
  const isDesktop = useSelector(selectDesktop);
  const country = useSelector(selectCurrentCountry);
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const actionData = widgetData?.media?.[0]?.action || null;
  const [currentSlider, setCurrentSlider] = useState(0);
  const clusterId = useSelector(getClusterId);
  const address = useSelector(selectDefaultAddress);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const categoryList = useSelector((state) => state.category);
  const productsMap = useSelector(selectProductEntities);
  const bogoProducts = useSelector((state) => state.product.bogoProdList);
  const autoScrollInterval = countryValidations.bannerTimeInterval * 1000;
  const location = useLocation();
  const navigate = useNavigate();
  const intl = useIntl();
  const axis = intl.locale === 'ar' ? 'x-reverse' : 'x';

  const handleSliderChange = (index) => {
    setCurrentSlider(index);
    clearTimeout(scrollTimerInstance);
    if (countryValidations.autoBanner && autoScrollInterval > 1) {
      scrollTimerInstance = setTimeout(() => {
        let nextSlideIndex = 0;

        nextSlideIndex = index === sortedList.length - 1 ? 0 : index + 1;

        handleSliderChange(nextSlideIndex);
      }, autoScrollInterval);
    }
  };

  React.useEffect(() => {
    if (!scrollTimerInstance) {
      handleSliderChange(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const linkto = {
    deeplink: `/${intl.locale}/store`,
    pickup_store: `/${intl.locale}/store`,
    category: `/${intl.locale}/deals/4`,
    menu: '',
    favourite: `/${intl.locale}/my-favorites/999`,
  };

  const handleBOGOProduct = () => {
    // add bogo and other hidden deals
    const categoryData = categoryList?.entities[actionData?.id];
    let subCategories = categoryData ? [categoryData] : [];

    subCategories = subCategories.map((subCategory) => {
      let subCategoryVariants = Object.values(categoryList?.entities || {}).filter(
        (subCategortVariant) => subCategortVariant?.parentId == subCategory?.id
      );

      subCategoryVariants = JSON.parse(JSON.stringify(subCategoryVariants));
      let products = [];
      let variantsArray = [];
      for (let i = 0; i < subCategoryVariants?.length; i++) {
        const steps = [
          {
            aKey: 'PHD_AE_v20_7_22_359_10598_1',
            assets: [{}],
            clusterKey: 'PHD_AE_v20_7_22',
            categories: [subCategory?.parentId],
            compId: parseInt(subCategoryVariants[i]?.id) * 10 + 1,
            groupId: 'PHD_AE_v20_7_22_359_10598',
            id: parseInt(subCategoryVariants[i]?.id) * 10 + 1,
            ingredient: 0,
            isAddon: 0,
            isDependent: 0,
            isHidden: 0,
            isModifier: 0,
            maximum: 1,
            minimum: 1,
            options: bogoProducts[subCategoryVariants[i]?.id],
            sCustomize: 1,
            subtitle: intl.formatMessage({ id: 'select_first_pizza' }),
            title: intl.formatMessage({ id: 'select_first_pizza' }),
            type: 'radio',
          },
          {
            aKey: 'PHD_AE_v20_7_22_359_10598_1',
            assets: [{}],
            clusterKey: 'PHD_AE_v20_7_22',
            categories: [subCategory?.parentId],
            compId: parseInt(subCategoryVariants[i]?.id) * 10 + 2,
            groupId: 'PHD_AE_v20_7_22_359_10598',
            id: parseInt(subCategoryVariants[i]?.id) * 10 + 2,
            ingredient: 0,
            isAddon: 0,
            isDependent: 0,
            isHidden: 0,
            isModifier: 0,
            maximum: 1,
            minimum: 1,
            options: bogoProducts[subCategoryVariants[i]?.id],
            sCustomize: 1,
            subtitle: intl.formatMessage({ id: 'select_second_pizza' }),
            title: intl.formatMessage({ id: 'select_second_pizza' }),
            type: 'radio',
          },
        ];

        variantsArray.push({
          isSelected: 0,
          title: subCategoryVariants[i]['name'],
          description: subCategoryVariants[i]['description'],
          id: subCategoryVariants[i]['id'],
        });

        products = products.concat({
          ...subCategoryVariants[i],
          categories: [subCategory?.parentId],
          sel1Value: subCategoryVariants[i]['id'],
          steps: steps,
          isHiddenDeal: true,
          isBOGO: true,
        });
      }
      const productStructure = {
        ...subCategory,
        categories: [subCategory?.parentId],
        variants: [
          {
            position: 1,
            orientation: 'vertical',
            id: 9999,
            selIndex: 1,
            title: intl.formatMessage({ id: 'please_choose_deal_size' }),
            subtitle: intl.formatMessage({ id: 'please_choose_deal_size' }),
            options: variantsArray,
          },
        ],
        items: products,
        bundleTypeId: 'bundle_group',
        typeId: 'bundle_group',
        isHiddenDeal: true,
        isBOGO: true,
      };

      if (!productsMap[subCategory?.id] && products.length) {
        dispatch(addNewProduct(productStructure));
      }
      return productStructure;
    });

    const category = categoryList.entities[subCategories[0]?.['categories']?.[0]];

    let productRoute = generateProductRoute({
      product: subCategories[0],
      category,
      locale: intl.locale.toLowerCase(),
    });
    productRoute = `${productRoute}/bundle`;
    navigate(productRoute, {
      state: { oldLocation: location },
    });
  };

  const handleClick = (target, action) => (e) => {
    e.preventDefault();
    if (target) {
      navigate(target);
    } else {
      // determine product
      if (
        Object.keys(bogoProducts || {})
          .map((item) => parseInt(item))
          .includes(action?.id)
      ) {
        // console.log(action, 'Action');
        // debugger;
        // bogo banner
        handleBOGOProduct();
      } else {
        // normal product
        const category = categoryList.entities[action?.category_id];
        const product = productsMap[action.id];
        let productRoute = generateProductRoute({
          product: product,
          category,
          locale: intl.locale.toLowerCase(),
        });
        if (product?.typeId === 'bundle') {
          productRoute = `${productRoute}/bundle`;
        }

        dispatch(
          addProductToCustomize({
            productType: product.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: product.id,
            data: {
              ...product,
              category: action?.category_id,
              noIncrement: true,
            },
          })
        );
        navigate(productRoute);
      }
    }
  };

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const checkIfInsideTiming = (startTime, endTime) => {
    let date = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    );
    let start = startTime.split(':');
    let end = endTime.split(':');

    const startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(start[0]),
      parseInt(start[1]),
      0
    );

    const endDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(end[0]),
      parseInt(end[1]),
      0
    );

    return startDate.getTime() <= date.getTime() && date.getTime() <= endDate.getTime();
  };

  const defaultTimings = { from: '00:00', to: '00:00' };
  const currentDayOfWeek =
    days[
      new Date(
        new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
      ).getDay()
    ];

  const checkIfAvil = (displayDays) => {
    let isItemAvailable = true;
    if (Object.values(displayDays || {}).length === 0) {
      isItemAvailable = true;
    } else {
      // debugger;
      const dayTimings = displayDays?.[currentDayOfWeek] || defaultTimings;
      let dealFallsInTiming = false;

      for (let timing of Array.isArray(dayTimings)
        ? dayTimings
        : Object.keys(dayTimings || {}).length > 0
        ? [dayTimings]
        : []) {
        if (checkIfInsideTiming(timing?.from, timing?.to)) {
          dealFallsInTiming = true;
          break;
        }
      }
      if (!dealFallsInTiming) {
        isItemAvailable = false;
      }
    }
    return isItemAvailable;
  };
  let sortedList = [];
  try {
    sortedList = compact(
      media.map((banner, id) => {
        const isAvailable = checkIfAvil(banner.displayDay);
        if (isAvailable) {
          return banner;
        }
      })
    );
  } catch (error) {
    console.error(error);
  }
  if (!sortedList.length) {
    return null;
  }

  return (
    <div className={css.root}>
      {/* <SwipeableViews
        axis={axis}
        animateTransitions={true}
        enableMouseEvents={true}
        slideClassName={css.blockItem}
        className={css.mediaContainer}
        index={currentSlider}
        onChangeIndex={setCurrentSlider}
      > */}
      {sortedList.map((banner, idx) => {
        const type = banner?.action?.type;

        if (
          type !== 'category' &&
          type !== 'subcategory' &&
          type !== 'product' &&
          type !== 'pickup_store'
        ) {
          return null;
        }

        let linkURL =
          isDesktop && (type === 'deeplink' || type === 'pickup_store')
            ? `${location.pathname}?modal=store`
            : linkto[type];
        const isStoreEnabled = orderModes?.filter((el) => el.type === 'STORE');
        if (linkURL?.includes('store') && !isStoreEnabled[0]?.enable) {
          linkURL = '';
        }

        const mediaURL = isDesktop ? addDesktopRepository(banner.mediaUrl) : banner.mediaUrl;
        if (linkURL !== '') {
          return (
            <a
              href={linkURL}
              onClick={handleClick(linkURL, banner.action)}
              className={css.banner}
              key={`banner-${banner.sequence}-${banner.mediaUrl}`}
            >
              <img
                className={css.imageflex}
                alt={''}
                effect="blur"
                src={`${mediaURL}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImg;
                }}
              />
              {content ? <div className={css.content}>{content}</div> : ''}
            </a>
          );
        } else {
          return (
            <div className={css.banner} key={`banner-${banner.sequence}-${banner.mediaUrl}`}>
              <img className={css.imageflex} alt={''} effect="blur" src={`${mediaURL}`} />
              {content ? <div className={css.content}>{content}</div> : ''}
            </div>
          );
        }
      })}
      {/* </SwipeableViews> */}
    </div>
  );
}
